// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1nI1-","App-logo":"App_App-logo__1_1zS","App-logo-spin":"App_App-logo-spin__1tVhi","App-header":"App_App-header__1uu9z","GameField":"App_GameField__3CEVc"};